import React from "react";

import Tab from "../Tab";
import "./AmexTabMenu.css";

export const AmexTabMenu = ({ tabProps, ...props }) => {
  return <Tab className="amex" tabProps={tabProps} {...props} />;
};
